import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../list/actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import store from '../../../../store';

function* deleteAssignment({ payload: { id, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.remove, id });

    dispatch(listActions.getAssignmentsRequest({ curr_page: getState().getAssignments.curr_page, status: 'draft' }));

    onSuccess && onSuccess();
    yield put(actions.deleteAssignmentDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteAssignmentFailed,
      endpoint: api.modifiers.assignments.remove.url
    });
  }
}

export const deleteAssignmentSaga = takeEvery(types.DELETE_ASSIGNMENT_REQUEST, deleteAssignment);